import { connect } from 'react-redux';
import { getIsVerificationNeeded } from '../publicSession/selectors';
import { pushVerificationPopup } from './actions';
var mapStateToProps = function (state) { return ({
    isVerificationNeeded: getIsVerificationNeeded(state),
}); };
var mapDispatchToProps = {
    pushVerificationPopup: pushVerificationPopup,
};
export function withVerification(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component); // redux types are not fond of generics
}
//# sourceMappingURL=withVerification.js.map